module.exports = __webpack_public_path__ + "img/cash-line.edd54f58.svg";